import React from 'react'
import createSvgIcon from 'client/icons/createSvgIcon'

export default createSvgIcon(
  <path d="M3 4h18c.6 0 1 .4 1 1v3c0 .6-.4 1-1 1h-1v6c0 2.3-2.2 6-8 6s-8-3.7-8-6V9H3c-.6 0-1-.4-1-1V5c0-.6.4-1 1-1zm9 15c4.4 0 6-2.5 6-4V9H6v6c0 1.5 1.6 4 6 4zm7-12h1V6H4v1h15zM9 15c0 .6-.4 1-1 1s-1-.4-1-1v-3c0-.6.4-1 1-1s1 .4 1 1v3zm3 1c.6 0 1-.4 1-1v-3c0-.6-.4-1-1-1s-1 .4-1 1v3c0 .6.4 1 1 1zm5-1c0 .6-.4 1-1 1s-1-.4-1-1v-3c0-.6.4-1 1-1s1 .4 1 1v3z" />,
  'SmokeDetector'
)
